export class ConceptType {
    id = null;
    name = null;
    code = null;
    description = null;
}